<template>
  <div class="purchase">
    <div>
      <div class="img" v-for="item in list" :key="item.id">
        <template v-if="item.id==id">
          <img :src="item.path" alt />
        </template>
      </div>
      <div class="course-info">
        <div class="f36 fb tl title">{{dataInfo.name}}</div>
        <div class="f24 tl title mt10">{{dataInfo.shareDescription}}</div>
        <div class="f32 tl fb color-333 mt50">时间地点：</div>
        <div class="info">
          <div class="color-333 tl">
            <span class="iconfont icon-shijian f36"></span>
            <span class="f30">{{time}}</span>
          </div>
          <div class="color-333 tl mt15">
            <span class="iconfont icon-dingwei f36"></span>
            <span class="f30">{{dataInfo.province}}|{{dataInfo.city}}</span>
          </div>
          <div class="f30 color-888 tl fl mt10">{{dataInfo.address}}</div>
        </div>
        <div class="f32 color-333 fb tl mb50">注意事项：</div>
        <div class="content" v-html="dataInfo.content"></div>
        <!--isSignUp 是否已经报名[0:未报名,1:已报名,2:报名已截止] -->
        <div class="purchase-footer hover-class" v-if="dataInfo.isSignUp==0" @click="submit">报名</div>
        <div class="purchase-footer" v-else >{{dataInfo.isSignUp==1?'已报名':'报名已截止'}}</div>
      </div>
      <!-- 已报名 已截止 -->
    </div>
  </div>
</template>

<script>
import dates from '@/utils/dates'
export default {
  props: {
    id: '',

    dataInfo: {},
  },
  data() {
    return {
      list: [
        {
          id: 1,
          name: '标杆游学',
          path: require('@/assets/images/vip/h-benchmarking.png'),
        },
        {
          id: 2,
          name: '深度研学',
          path: require('@/assets/images/vip/h-research.png'),
        },
        {
          id: 3,
          name: '围炉夜话',
          path: require('@/assets/images/vip/h-talk.png'),
        },
      ],
      time: '',
    }
  },
  mounted() {
    this.getTime()
  },
  watch: {
    dataInfo: {
      handler: function () {
        this.getTime()
      },
      deep: true,
    },
  },
  methods: {
    submit() {
      this.$emit('submit')
    },

    setTime(value) {
      if (!value) return '- -'
      return dates.formatDate(new Date(value), 'yyyy-MM-dd')
    },
    dateForma(value) {
      if (!value) return '- -'
      return dates.formatDate(new Date(value), 'hh:mm')
    },
    dateFormaAll(value) {
      if (!value) return '- -'
      return dates.formatDate(new Date(value), 'yyyy-MM-dd hh:mm')
    },
    getTime() {
      if (
        this.setTime(this.dataInfo.startTime) ==
        this.setTime(this.dataInfo.endTime)
      ) {
        this.time =
          this.dateFormaAll(this.dataInfo.startTime) +
          '  ～  ' +
          this.dateForma(this.dataInfo.endTime)
      } else {
        this.time =
          this.dateFormaAll(this.dataInfo.startTime) +
          '   ～   ' +
          this.dateFormaAll(this.dataInfo.endTime)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.purchase {
  padding-top: 100px;

  .img {
    img {
      width: 100%;
      height: 186px;
    }
  }

  .course-info {
    width: 100%;
    height: 886px;
    padding: 40px 32px 40px 32px;
    margin-top: -10px;
    // box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: hidden;
    position: relative;
    box-shadow: 2px 2px 10px #d3d3d3;
    border-radius: 0 0 12px 12px;

    .title {
      color: #854f1d;
    }

    .info {
      // flex: 1;
      // font-weight: bold;
      margin: 30px 0;

      span {
        font-weight: 500;
        display: inline-block;
      }
    }

    .content {
      width: 100%;
      height: 270px;
      overflow-x: scroll;
      text-align: left;
    }

    .text {
      width: 60px;
    }

    .hover-class {
      color: #714a33 !important;
      background: linear-gradient(90deg, #ffe1c4 0%, #f5af68 100%) !important;
    }

    .purchase-footer {
      // padding:24px 24px ;
      width: 282px;
      height: 80px;
      font-weight: 600;
      font-size: 32px;
      line-height: 80px;
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translate(-50%);
      color: #ffffff;
      background: linear-gradient(90deg, #e4e4e4 0%, #d4d4d4 100%);
      border-radius: 40px;
    }
  }
}
</style>
